export default __webpack_public_path__ + "static/media/pull.c6d3fc83.mp3";